import { ReactNode, useState } from "react";
import { isTextEllipsed } from "../../utils/general_utils";
import { Tooltip, TypographyProps } from "@mui/material";

type Props = TypographyProps & {
  tooltip: string;
  children?: ReactNode;
  style?: React.CSSProperties | undefined;
  placement?: "bottom" | "top";
  maxWidth?: string;
  onlyEllipsis?: boolean;
};

export const ReuseEllipsisTooltip = ({
  tooltip,
  style,
  placement = "top",
  maxWidth,
  children,
  onlyEllipsis = true,
}: Props) => {
  const [showTableTooltip, setShowTableTooltip] = useState(false);

  const handleMouseEnter = (e: React.MouseEvent<HTMLDivElement>) => {
    const target = e.currentTarget;
    setShowTableTooltip(isTextEllipsed(target));
  };

  return (
    <Tooltip
      title={(showTableTooltip || !onlyEllipsis) && tooltip}
      placement={placement}
      slotProps={{
        tooltip: {
          sx: {
            maxWidth,
          },
        },
      }}
      arrow
    >
      <span
        onMouseEnter={handleMouseEnter}
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "block",
          ...style,
        }}
      >
        {children}
      </span>
    </Tooltip>
  );
};
